/* eslint-disable eag/match-named-export, eag/no-index -- Pre-existing grab-bag file with several exports. Pre-existing violation */
// Omnetic tokens mirrored as literals — eag-grid does not consume the
// styled-components theme, so colours are inlined (see project conventions).
export const FG_PRIMARY = '#091E42';
export const FG_SECONDARY = '#42526E';
export const FG_TERTIARY = '#7A869A';
export const NEUTRAL_20 = '#F4F5F7';
export const NEUTRAL_30 = '#EBECF0';
export const SWITCH_OFF = '#7A869A';
export const BLUE_60 = '#0065FF';
export const BLUE_70 = '#0052CC';
export const ELEV_1 = '0px 1px 4px rgba(0, 0, 0, 0.12)';
